import { React, useEffect, useState, useContext } from "react";
import MiningAndElectricitySectorData from "../../../../Components/MiningAndElectricitySectorData";
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import {
  shortMonthToFull,
  handleUserLevelAccessPermissions,
  getAllYears,
  validateRolesIIP,
  shortMonthToMonthNumber
} from "../../../../Custom/Custom";
import { ToastContainer, toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import messages from '../../../../assets/Messages.json';
import titlesData from '../../../../titles.json';

function ElectricitySector() {
  const [years, setYears] = useState([]);
  const [months, setMonth] = useState([]);
  const [yearName, setYearName] = useState("");
  const [monthName, setMonthName] = useState("");
  const [sectorData, setSectorData] = useState([]);
  const [payload, setPayload] = useState([]);
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });
  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  
useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);
  //Get all Months data
    const getMonthsList = (e) => {
      showLoading(true);
      axios
        .get(`${API_URL}api/graph/getMonths/2019`, config)
        .then((res) => {
          let monthDataResponse = res.data;
          if (monthDataResponse.status) {
            setMonth(monthDataResponse.data);
            showLoading(false);
          }
        })
        .catch((err) => {
          console.error(err);
          showLoading(false);
        });
    };

    const getYearList = () => {
      setYears(getAllYears());
    };

    const userRole = async () => {
      showLoading(true);
      try {
        const role = await validateRolesIIP(decode_token);
        if (role) {
          getYearList();
          getMonthsList();
       } else {
          alert(
            "You are not an authorised user to capture IIP Electricity Sector Data."
          );
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false);
      }
    };

    userRole();
  }, []);


  const handleDropdownChange = (e) => {

   

    switch (e.target.name) {
     case "month_name":
        setMonthName(e.target.value);
        setYearName("");
        break;
      case "year_name":
        if(monthName ===''){
          toast.error('Select Month', messages.COLOR_RED);
          return false;
        }
      let currentYear = new Date().getFullYear();
      let selectedYear=parseInt(e.target.value)

      if (selectedYear > currentYear) {
          toast.error('Invalid Year Selection.', messages.COLOR_RED);
          return false;
      }else if (selectedYear === currentYear) {

        let currentMonth =  new Date().getMonth() + 1;
        let selectedMonth= shortMonthToMonthNumber(monthName);
        currentMonth= currentMonth<10 ? `0${currentMonth}` :currentMonth;
      if(selectedMonth>currentMonth){
          toast.error('Invalid Month Selection.', messages.COLOR_RED);
          setMonthName('')
          setYearName('')
          return false;
      }
    }
     setYearName(e.target.value)
        let postData = {
          month: monthName,
          year: e.target.value,
          
        };
        onChangeYearDataForMiningSector(postData);

        break;
      default:
        console.log("switch case are not match");
        break;
    }
  };


//get Mining Sector Data
const onChangeYearDataForMiningSector=async(postData)=>{
    showLoading(true);

    try {
      const response = await axios.post(
        `${API_URL}api/iip/iipElectricitySector`,
        postData,
        config
      );
    
    if (response.data.status) {
        setSectorData(response.data.data.iipElectricitySector);
        setPayload(response.data.data.payload);
        showLoading(false);
      }else{
        toast.error("No Data Found For this Month and Year", messages.COLOR_RED);
      }
    } catch (error) {
      console.error("Error posting data:", error);
      showLoading(false);
    }

  }


  const resetFormData=()=>{
    setYearName("")
    setMonthName("")
    setSectorData("")
  }

  const handleMiningSectorValidation=()=>{

    if(monthName===''){
       toast.error(messages.MONTH_MSG, messages.COLOR_RED);
       return false;
    }

    if(yearName===''){
       toast.error(messages.YEAR_NAME_MSG, messages.COLOR_RED);
       return false;
    }
     return true;
}

const storedLanguage = localStorage.getItem('language');

  return (
    <>
    <GlobalLoading />
    <ToastContainer />
    <div className="container-fluid py-3">
      <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="row align-items-center">
            <h4 className="page_heading">
            <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? titlesData.hi.IIP_ELECTRICITY_SECTOR : titlesData.en.IIP_ELECTRICITY_SECTOR }} />
            </h4>

            <div className="row align-items-center">
           
              

              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? titlesData.hi.MONTH : titlesData.en.MONTH}</label>
                <select
                  name="month_name"
                  className="form-select"
                  onChange={handleDropdownChange}
                  value={monthName}
                >
                  <option value="" disabled>
                    Select Month
                  </option>
                  {months &&
                    months.map((ele, i) => (
                      <option key={i} value={ele.MONTH}>
                        {shortMonthToFull(ele.MONTH)}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? titlesData.hi.YEAR : titlesData.en.YEAR}</label>
                <select
                  name="year_name"
                  className="form-select"
                  onChange={handleDropdownChange}
                  value={yearName}
                >
                  <option value="" disabled>
                    Select Year
                  </option>
                  {years &&
                    years.map((ele, index) => (
                      <option key={index} value={ele}>
                        {ele}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-xl-8 col-lg-3 col-md-3 col-sm-4 col-6 mb-3 text-end">
                <small>{storedLanguage === 'hi' ? titlesData.hi.MANDATORY_FIELDS : titlesData.en.MANDATORY_FIELDS} <span className="text-danger">*</span></small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card mx-3 mb-3">
        {sectorData.length === 1 ? (
          <MiningAndElectricitySectorData
           type="ElectricitySector"
           config={config}
           resetFormData={resetFormData}
            userInfoObject={buttonAccess}
            yearName={yearName}
            monthName={monthName}
            allSectorData={sectorData}
            payload={payload}
            url="iip/IIPElectricitySectorDetailsSaveDB"
            storedLanguage={storedLanguage}
            titlesData={titlesData}
          />
        ):
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered">
                  <thead>
                  <tr>
                 
                    <th className="text-center">{storedLanguage === 'hi' ? titlesData.hi.ITEM_CODE : titlesData.en.ITEM_CODE}</th>
                    <th className="text-center">{storedLanguage === 'hi' ? titlesData.hi.UNIT : titlesData.en.UNIT}</th>
                    <th className="text-center">{storedLanguage === 'hi' ? titlesData.hi.QUANTITY_PRODUCED : titlesData.en.QUANTITY_PRODUCED}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                    
                     
                      <td>
                        {storedLanguage === 'hi' ? titlesData.hi.ELECTRICITY : titlesData.en.ELECTRICITY}
                        <input 
                        type="hidden" 
                        className="form-control" 
                        name="item_Coal1" 
                        id="item_Coal1" 
                        disabled
                        value="Electricity"/>
                        </td>
                      <td>
                        <input 
                        type="hidden" 
                        className="form-control" 
                        name="Unit1" 
                        id="Unit1" 
                        disabled="" 
                        value=""/>
                       </td>
                      <td>
                        <input 
                        type="text" 
                        className="form-control" 
                        name="coal_produced1" 
                        id="coal_produced1" 
                        maxLength="12" 
                        value=""
                        onChange={(e) => handleMiningSectorValidation(e, 'SAVE')}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="row">
                <div className="col-12 text-center pt-3">
                
                <button
                  onClick={(e) => handleMiningSectorValidation(e, 'SAVE')}
                  type="button"
                  className="btn btn_orange mx-1"
                 >Save
                </button>
                
                  <button 
                  onClick={(e)=>handleMiningSectorValidation(e,'ACCEPT')}   
                  type="button" 
                  className={`btn btn_orange mx-`}
                  >Accept
                  </button>
                
                  <button 
                    type="reset" 
                    className="btn btn_orange mx-1" 
                    onClick={resetFormData} 
                    >
                    Reset
                  </button>

                <button 
                  type="button" 
                  className="btn btn_orange mx-1" 
                  onClick={(e)=>( navigate("/dashboard"))}
                  >
                  Cancel
                </button>
            </div>
                </div>

          </div>
       }
      </div>
    </div>
   </>
  )
}

export default ElectricitySector